import * as Sentry from '@sentry/react'
import type { AnyRouter } from '@tanstack/react-router'

/**
 * Takes the router so route transitions are instrumented — which is also why main.tsx builds the
 * router before calling this.
 *
 * On `integrations`: an empty array here used to read as "no integrations", but Sentry merges a
 * user array with the defaults rather than replacing them (only a callback replaces them), so the
 * defaults — globalHandlers, breadcrumbs, dedupe — were active all along and the key did nothing.
 * What was genuinely missing is browser tracing: it is NOT a default in the npm browser SDK, so
 * `tracesSampleRate` below was sampling a transaction source that never existed.
 */
export const initSentry = (router: AnyRouter) => {
  return Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.VITE_DEV !== 'true',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    release: `${import.meta.env.VITE_APP_NAME}@${import.meta.env.VITE_APP_VERSION}`,
    sendDefaultPii: false,
    tracesSampleRate: 0.2,
  })
}
